import React from 'react';

import * as Style from '../style.module.scss';

const Field: React.FC<{ label: string; value: string }> = ({ label, value }) => (
    <div className={Style.field}>
        <span className={Style.fieldLabel}>{label}</span>
        <span className={Style.fieldValue}>{value}</span>
    </div>
);

export default Field;
